import { z } from 'zod';

const timeEntryItemSchema = z.object({
  startTime: z.string().min(1, 'Start time is required'),
  stopTime: z.string().min(1, 'Stop time is required'),
  hours: z.string(),
  minutes: z.string(),
  seconds: z.string(),
  _id: z.string().optional(),
}).refine((data) => {
  const start = new Date(data.startTime);
  const stop = new Date(data.stopTime);
  return stop > start;
}, {
  message: "Stop time must be after start time",
  path: ["stopTime"]
});

export const timeEntrySchema = z.object({
  entries: z.array(timeEntryItemSchema)
});

export type TimeEntryItem = z.infer<typeof timeEntryItemSchema>;
export type FormInputs = z.infer<typeof timeEntrySchema>;
